type Props = {
	numAvailable: number
	numOnDeck: number
}
export default function NumAvailableCategories ({numAvailable, numOnDeck} : Props) {
	return <div>There {numAvailable === 1 ? 'is' : 'are'} {numAvailable === numOnDeck ? 'only ' : ''}{numAvailable} categor{numAvailable === 1 ? 'y' : 'ies'} left</div>
}
